var map = {
	"./zhiding_d.png": "FMz0",
	"./zhiding_l.png": "ehWA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9DjI";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/zhiding_.*\.png$
// module id = 9DjI
// module chunks = 12